import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=4f64bc17&scoped=true&"
import script from "./MainTable.vue?vue&type=script&lang=js&"
export * from "./MainTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f64bc17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f64bc17')) {
      api.createRecord('4f64bc17', component.options)
    } else {
      api.reload('4f64bc17', component.options)
    }
    module.hot.accept("./MainTable.vue?vue&type=template&id=4f64bc17&scoped=true&", function () {
      api.rerender('4f64bc17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/project-detail/WallList/MainTable.vue"
export default component.exports